import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
const TermsAndConditions = () => {
  return (
    <>
      <Navb />
      <Container className="terms-and-conditions">
        <h1>Terms & Conditions</h1>
        <p>Last updated: 19-05-2024</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Welcome to Udaya Solution ("us", "we", or "our"). These Terms &
            Conditions ("Terms", "Terms & Conditions") govern your relationship
            with the [https://udayasoln.netlify.app] website (the "Service")
            operated by Udaya Solution.
          </p>
          <p>
            Please read these Terms & Conditions carefully before using our
            Service. Your access to and use of the Service is conditioned on
            your acceptance of and compliance with these Terms. These Terms
            apply to all visitors, users, and others who access or use the
            Service.
          </p>
        </section>

        <section>
          <h2>Use of the Service</h2>
          <p>
            By using our Service, you agree to use it in accordance with these
            Terms. The Service is intended for users to apply for job
            opportunities easily. You agree to provide accurate, current, and
            complete information when applying for job opportunities through our
            Service.
          </p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            The Service and its original content (excluding Content provided by
            users), features, and functionality are and will remain the
            exclusive property of Udaya Solution and its licensors. The Service
            is protected by copyright, trademark, and other laws of both the
            United States and foreign countries. Our trademarks and trade dress
            may not be used in connection with any product or service without
            the prior written consent of Udaya Solution.
          </p>
        </section>

        <section>
          <h2>Links To Other Web Sites</h2>
          <p>
            Our Service may contain links to third-party web sites or services
            that are not owned or controlled by Udaya Solution.
          </p>
          <p>
            Udaya Solution has no control over and assumes no responsibility
            for, the content, privacy policies, or practices of any third-party
            web sites or services. You further acknowledge and agree that Udaya
            Solution shall not be responsible or liable, directly or indirectly,
            for any damage or loss caused or alleged to be caused by or in
            connection with use of or reliance on any such content, goods, or
            services available on or through any such web sites or services.
          </p>
          <p>
            We strongly advise you to read the terms and conditions and privacy
            policies of any third-party web sites or services that you visit.
          </p>
        </section>

        <section>
          <h2>Termination</h2>
          <p>
            We may terminate or suspend your access to the Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms.
          </p>
          <p>
            Upon termination, your right to use the Service will immediately
            cease. If you wish to terminate your use of the Service, you may
            simply discontinue using the Service.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            In no event shall Udaya Solution, nor its directors, employees,
            partners, agents, suppliers, or affiliates, be liable for any
            indirect, incidental, special, consequential, or punitive damages,
            including without limitation, loss of profits, data, use, goodwill,
            or other intangible losses, resulting from (i) your access to or use
            of or inability to access or use the Service; (ii) any conduct or
            content of any third party on the Service; (iii) any content
            obtained from the Service; and (iv) unauthorized access, use, or
            alteration of your transmissions or content, whether based on
            warranty, contract, tort (including negligence), or any other legal
            theory, whether or not we have been informed of the possibility of
            such damage, and even if a remedy set forth herein is found to have
            failed of its essential purpose.
          </p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>
            Your use of the Service is at your sole risk. The Service is
            provided on an "AS IS" and "AS AVAILABLE" basis. The Service is
            provided without warranties of any kind, whether express or implied,
            including, but not limited to, implied warranties of
            merchantability, fitness for a particular purpose, non-infringement,
            or course of performance.
          </p>
          <p>
            Udaya Solution, its subsidiaries, affiliates, and its licensors do
            not warrant that a) the Service will function uninterrupted, secure,
            or available at any particular time or location; b) any errors or
            defects will be corrected; c) the Service is free of viruses or
            other harmful components; or d) the results of using the Service
            will meet your requirements.
          </p>
        </section>

        <section>
          <h2>Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the
            laws of [Your Country], without regard to its conflict of law
            provisions.
          </p>
          <p>
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service, and supersede and replace any prior agreements we might
            have had between us regarding the Service.
          </p>
        </section>

        <section>
          <h2>Changes</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. If a revision is material we will try to
            provide at least 30 days notice prior to any new terms taking
            effect. What constitutes a material change will be determined at our
            sole discretion.
          </p>
          <p>
            By continuing to access or use our Service after those revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, please stop using the Service.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us via
            our <a href="/contact">Contact Us</a> page.
          </p>
        </section>
      </Container>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
